"use client";

import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { getTaxLabelKey } from "@/utils/helpers/tax";

export const useTaxSettings = () => {
  const { data } = useGetCompanyQuery();
  const mode = data?.result.preferences?.tax_mode ?? "exclusive";
  return {
    mode,
    enabled: data?.result.preferences?.enable_taxes ?? true,
    labelKey: getTaxLabelKey(mode),
  };
};
